import React from 'react'
import classNames from 'classnames'

import ItemTileInformation from '../../itemTile/ItemTileInformation'
import ItemTileCover from '../../itemTile/ItemTileCover'
import ProductDescription from '../../itemTile/ItemTileDescription'
import PropTypes from 'prop-types'

class ProductTile extends React.Component {
  constructor (props) {
    super(props)

    this.product = this.props.product
    this.card = React.createRef()
  }

  titleHeightChange (newHeight) {
    this.props.cardHeightChange(this.props.idx, newHeight)
  }

  render () {
    this.productTileClasses = classNames('product-card', 'product-tile', {
      'has-description': this.props.hasDescription,
      hover: this.props.hoverable
    })

    let description = this.props.hasDescription ? (
      <ProductDescription description={this.props.product.description} />
    ) : null

    let coverPhotoUrl
    if (this.product.coverPhoto) {
      coverPhotoUrl = this.product.coverPhoto.url
    }

    return (
      <div
        id={`card-${this.props.idx}`}
        className={this.productTileClasses}
        onTransitionEnd={this.props.transitionEnd}
        onMouseEnter={() => {
          this.props.mouseEnterAction(this.card.current)
        }}
        onMouseLeave={this.props.mouseLeaveAction}
        ref={this.card}
      >
        <ItemTileCover
          coverPhoto={coverPhotoUrl}
          primaryCategory={this.product.primaryCategory}
          itemUrl={this.product.url()}
          type={this.product.type}
        />
        <ItemTileInformation
          product={this.props.product}
          coaches={this.props.product.coaches}
          difficultyLevel={this.props.product.difficultyLevel}
          workoutCount={this.props.product.workoutCount}
          itemUrl={this.product.url()}
          onTitleHeightChange={this.titleHeightChange.bind(this)}
          title={this.props.product.title}
          memberCount={this.props.product.memberCount}
        />
        {description}
      </div>
    )
  }
}

ProductTile.defaultProps = {
  hasDescription: false,
  cardHeightChange: () => {},
  mouseEnterAction: () => {},
  mouseLeaveAction: () => {}
}

ProductTile.propTypes = {
  cardHeightChange: PropTypes.func,
  hasDescription: PropTypes.bool,
  hoverable: PropTypes.bool,
  idx: PropTypes.number,
  mouseEnterAction: PropTypes.func,
  mouseLeaveAction: PropTypes.func,
  product: PropTypes.object,
  transitionEnd: PropTypes.func
}

export default ProductTile
